import { Component } from '@angular/core';

/**
 * Composant de l'onglet workflow
 */
@Component({
	host: {'data-test-id': 'admin-workflow'},
	templateUrl: './admin-workflow.component.html'
})
export class AdminWorkflowComponent {}